var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "createEmailModal",
    attrs: {
      id: "create-email-modal",
      "modal-dialog-size": "md",
      "modal-header": false,
      "modal-dialog-scrollable": false,
    },
    on: { show: _vm.handleShow, hidden: _vm.handleHidden },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _vm.modalOpened
              ? [
                  !_vm.showVerify
                    ? _c("campaign-email-creation")
                    : _c("campaign-email-verification", {
                        attrs: {
                          "show-not-verified-mssg": _vm.showNotVerifiedMssg,
                        },
                      }),
                ]
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _vm.showVerify
              ? _c(
                  "simple-button",
                  {
                    key: "verify-button",
                    ref: "verifyEmail",
                    attrs: {
                      "class-name": "btn btn-sm btn-primary",
                      type: "button",
                      loading: _vm.verifying.loading,
                      "loading-succeeded": _vm.verifying.status,
                    },
                    on: { click: _vm.handleVerifyEmail },
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.$t("global.words.verify")) +
                        "\n    "
                    ),
                  ]
                )
              : _c(
                  "simple-button",
                  {
                    key: "save-button",
                    ref: "createEmail",
                    attrs: {
                      "class-name": "btn btn-sm btn-primary",
                      loading: _vm.submitting.loading,
                      "loading-succeeded": _vm.submitting.status,
                      disabled: !_vm.isValid,
                    },
                    on: { click: _vm.handleCreateEmail },
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.$t("global.words.create")) +
                        "\n    "
                    ),
                  ]
                ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }